import ErrorSection from 'modules/errors/section/ErrorSection';
import {ERROR_BOUNDARY_INFO} from 'modules/errors/constants';

const ErrorBoundaryPage = () => {
    const {description, buttonText} = ERROR_BOUNDARY_INFO;

    const handleReloadPage = () => {
        window.location.reload();
    };

    return <ErrorSection buttonText={buttonText} description={description} onClick={handleReloadPage} />;
};

export default ErrorBoundaryPage;
